<template>
  <div class="bg dataScreen">
    <div class="mainCon bg dataScreen">
      <div class="head">
        <div class="title-left" />
        <h1>消防控制室人员管理平台</h1>
        <div class="title-right" />
        <!--      <div class="time">-->
        <!--        {{date}}-->
        <!--        <div id="weather-v2-plugin-simple"></div>-->
        <!--      </div>-->
        <el-button
          class="button1"
          @click="$router.push('/system/certificate')"
          type="primary"
          >待审核<b>{{ certificate }}</b
          >人</el-button
        >
        <el-button class="button2" @click="$router.push('/')" type="primary"
          >进入后台</el-button
        >
        <el-button class="button2" @click="$router.push('/')" type="primary"
          >进入后台</el-button
        >
      </div>
      <el-row class="box">
        <div class="conFirst con">
          <div
            class="smallBox"
            @click="$router.push({ path: '/unit', query: { isEro: 0 } })"
            style="cursor: pointer;"
          >
            <!-- <span data-to="3190" data-speed="10600">{{ box.units }}</span> -->
            <countTo
              :startVal="0"
              :endVal="box.units"
              :duration="5000"
            ></countTo>
            <p style="padding-right: 40px; text-align: center;">
              消防控制室数(间)
            </p>
          </div>
          <div
            class="smallBox"
            @click="$router.push({ path: '/unit', query: { isEro: 1 } })"
            style="cursor: pointer;"
          >
            <!-- <span style="color: #ffc000;">{{ errUnit }}</span> -->
            <countTo
              :startVal="0"
              :endVal="errUnit"
              :duration="5000"
              style="color: #ffc000;"
            ></countTo>
            <p style="padding-right: 40px; text-align: center; color: #ffc000;">
              异常控制室(间)
            </p>
          </div>
          <div
            class="smallBox"
            @click="$router.push({ path: '/system/emp', query: { status: 1 } })"
            style="cursor: pointer;"
          >
            <!-- <span>{{ box.dutyNum }}</span> -->
            <countTo
              :startVal="0"
              :endVal="box.dutyNum"
              :duration="5000"
            ></countTo>
            <p style="padding-right: 40px; text-align: center;">上岗人数(人)</p>
          </div>
          <div
            class="smallBox"
            @click="
              $router.push({ path: '/system/emp', query: { isCertificate: 1 } })
            "
            style="cursor: pointer;"
          >
            <!-- <span>{{ box.licensed }}</span> -->
            <countTo
              :startVal="0"
              :endVal="box.licensed"
              :duration="5000"
            ></countTo>
            <p style="padding-right: 40px; text-align: center;">持证人员(人)</p>
          </div>
          <div
            class="smallBox"
            @click="
              $router.push({ path: '/system/emp', query: { isCheck: 1 } })
            "
            style="cursor: pointer;"
          >
            <!-- <span>{{ box.sign }}</span> -->
            <countTo
              :startVal="0"
              :endVal="box.sign"
              :duration="5000"
            ></countTo>
            <p style="padding-right: 40px; text-align: center;">实时在岗(人)</p>
          </div>
          <div
            class="smallBox"
            @click="
              $router.push({ path: '/system/emp', query: { isExpire: 1 } })
            "
            style="cursor: pointer;"
          >
            <!-- <span style="color: #ffc000;">{{ expired }}</span> -->
            <countTo
              :startVal="0"
              :endVal="expired"
              :duration="5000"
              style="color: #ffc000;"
            ></countTo>
            <p style="padding-right: 40px; text-align: center; color: #ffc000;">
              证书到期
            </p>
          </div>
          <div
            class="smallBox"
            @click="
              $router.push({ path: '/system/event', query: { isExpire: 1 } })
            "
            style="cursor: pointer;"
          >
            <!-- <span style="color: #ffc000;">{{ expired }}</span> -->
            <countTo
              :startVal="0"
              :endVal="abnormalNum"
              :duration="5000"
              style="color: #ffc000;"
            ></countTo>
            <p style="padding-right: 40px; text-align: center; color: #ffc000;">
              当日异常行为
            </p>
          </div>
        </div>
        <!-- <div class="conSecond con">
          <div @click="$router.push({path: '/system/emp', query: {isEro: 0}})" style="cursor: pointer; background-color: #22c8e1; border-radius: 7px;">
            <p>上岗人数</p>
            <span>{{ box.dutyNum }}</span>
          </div>
          <div @click="$router.push({path: '/system/emp', query: {isEro: 0}})" style="cursor: pointer; background-color: #37d35b; border-radius: 7px;">
            <p>持证人员</p>
            <span>{{ box.licensed }}</span>
          </div>
          <div @click="$router.push({path: '/system/emp', query: {isEro: 0}})" style="cursor: pointer; background-color: #cc55f3; border-radius: 7px;">
            <p>实时在岗</p>
            <span>{{ box.sign }}</span>
          </div>
          <div @click="$router.push({path: '/system/emp', query: {isEro: 0}})" style="cursor: pointer; background-color: #f36f55; border-radius: 7px;">
            <p>证书到期</p>
            <span>{{ expired }}</span>
          </div>
        </div> -->
      </el-row>
      <el-row type="flex" justify="space-between" class="table">
        <!-- <el-col class="table-item tjcon_1" style="height: 100%; width: 15%;">
          <div class="modification_tl"></div>
          <div class="modification_tr"></div>
          <div class="modification_br"></div>
          <div class="modRbg"></div>
          <div class="chart2"> -->
        <!-- <h1>一周消控室合格率</h1> -->
        <!-- <div id="bar" style="width: 100%; height:100%;"></div>
          </div> -->
        <!-- <div class="chart2">
            <h1>消控室状态占比</h1>
            <dv-active-ring-chart :config="levelDataNormalEquip" style="width:100%;height:100%;" />
          </div>
          <div class="chart2">
            <h1>正常率</h1>
            <dv-water-level-pond :config="normalWater" style="width:100%;height:100%" />
          </div> -->
        <!-- </el-col> -->
        <el-col class="table-item tjcon_1" style="height: 100%; width: 18%;">
          <div class="modification_tl"></div>
          <div class="modification_tr"></div>
          <div class="modification_br"></div>
          <div class="modRbg"></div>
          <h1 class="unitInfoTitle">
            <span class="dwxxcon_title_1" />
            <span class="context" style="font-size: 1em;">预警报告</span>
            <span class="dwxxcon_title_3" />
          </h1>
          <div class="scroll-con">
            <div
              class="marquee-list"
              :class="{ 'animate-up': animateUp }"
              @mouseover="selectStyle()"
              @mouseout="outStyle()"
            >
              <div v-for="(item, index) in warningReportList" :key="index">
                <el-popover placement="top-start" width="300" trigger="hover">
                  <!-- <div class="info">
                    <p>名称：{{ item.unitName }}</p>
                    <p>地址：{{ item.unitAddress }}</p>
                    <p>负责人：{{ item.unitUser }} {{ item.unitTel }}</p>
                    <p style="color: red">异常原因：{{ item.errorMsg }}</p>
                    <div class="userList">
                      <div class="userList-con" v-for="(user, index) in item.users" :key="index"
                        style="position: relative">
                        <img :src='user.userpicPath' alt="" style="height: 100px; object-fit: contain">
                        <p>{{ user.realName }}<i class="el-icon-notebook-2" :class="userClass(user.bookState)"></i></p>
                        <i class="el-icon-success" :class="userAttState(user.attState)"
                          style="position: absolute; top: 0; right: 0;"></i>
                      </div>
                    </div>
                  </div> -->
                  <div class="info">
                    {{ item }}
                  </div>
                  <p slot="reference">
                    <span style="color: #ffc000">{{ item }}</span>
                  </p>
                </el-popover>
              </div>
            </div>
          </div>
        </el-col>
        <el-col
          class="table-item tjcon_1"
          style="height: 100%; width: 18%; margin: 0 1%"
        >
          <div class="modification_tl"></div>
          <div class="modification_tr"></div>
          <div class="modification_br"></div>
          <div class="modRbg"></div>
          <el-select
            v-model="unitId"
            placeholder="请选择消控室名称"
            filterable
            clearable
            @change="selectChange"
            class="unitSelect"
          >
            <el-option
              v-for="(item, index) in allUnits"
              :key="index"
              :value="item.id"
              :label="item.unitName"
            />
          </el-select>
          <div class="video-content">
            <swiper
              ref="mySwiper"
              :options="swiperOption"
              style="width: 100%; padding: 30px 1%"
            >
              <swiper-slide
                v-for="(item, index) in videoList"
                :key="index"
                :class="{ videoActive: nowIndex === index }"
              >
                <div class="video-item">
                  <div class="video-title" @click="videoClick(item, index)">
                    <div class="video-title-name oneline">
                      {{ item.cameraName }}
                    </div>
                    <div class="video-title-status">
                      <i />
                      <span>实时视频</span>
                      <span
                        v-if="
                          item.vrPath !== undefined &&
                          item.vrPath !== null &&
                          item.vrPath !== ''
                            ? true
                            : false
                        "
                        @click="toVr(item.vrPath)"
                        style="cursor: pointer"
                      >
                        VR
                      </span>
                    </div>
                  </div>
                  <div class="video-content-content">
                    <video-item :ref="'video' + index" :video-obj="item" />
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div
              ref="videoLeft"
              slot="button-prev"
              class="swiper-prev"
              style="left: 50%; top: -10px; position: absolute; outline: none; z-index: 999"
            >
              <i
                class="el-icon-arrow-up"
                style="color: #fff; font-size: 2em; cursor: pointer"
              />
            </div>
            <div
              ref="videoRight"
              slot="button-next"
              class="swiper-next"
              style="left: 50%; bottom: -10px; position: absolute; outline: none; z-index: 999"
            >
              <i
                class="el-icon-arrow-down"
                style="color: #fff; font-size: 2em; cursor: pointer"
              />
            </div>
          </div>
        </el-col>
        <el-col
          class="table-item"
          style="width: 44%; margin-right:1%; border: 12px ridge #0776ab; border-radius: 0;"
        >
          <div
            v-if="activeVideo !== null"
            class="video-item"
            :modal="activeVideo"
          >
            <div class="video-title">
              <div class="video-title-name">
                {{ activeVideo.cameraName }}
                <i />
              </div>
              <div class="video-title-status">
                <!-- <i /> -->
                <!-- <span
                  @click="changeVideo('live')"
                  :class="{ selected: currentOption === 'live' }"
                  >实时视频</span
                >
                <span
                  @click="changeVideo('soldier')"
                  :class="{ selected: currentOption === 'soldier' }"
                  >单兵视频</span
                > -->
                <span
                  :class="{ selected: currentOption === 'live' }"
                  >实时视频</span
                >
                <span
                  @click="goPoliceProtectionLinkage"
                  :class="{ selected: currentOption === 'soldier' }"
                  >指挥调度</span
                >
                <span
                  v-if="
                    activeVideo.vrPath !== undefined &&
                    activeVideo.vrPath !== null &&
                    activeVideo.vrPath !== ''
                      ? true
                      : false
                  "
                  @click="toVr(activeVideo.vrPath)"
                  style="cursor: pointer"
                >
                  VR
                </span>
              </div>
            </div>
            <div class="video-content-content">
              <div class="videoBox" v-if="!flag">
                <video-item :video-obj="activeVideo" />
              </div>
              <div class="videoBox" v-else>
                <div v-if="flagflv" class="flvBox">
                  <div
                    ref="videoLeft"
                    slot="button-prev"
                    class="swiper-prev-1"
                    style=" outline: none; z-index: 999"
                  >
                    <i
                      class="el-icon-arrow-left"
                      style="color: #fff; font-size: 2em; cursor: pointer"
                    />
                  </div>
                  <swiper ref="swiper1" class="swiper" :options="swiperOption1">
                    <swiper-slide
                      v-for="(item, index) in camareList"
                      :key="index"
                    >
                      <div class="swiperSlideItem">
                        <div class="flvVideoBox">
                          <!-- <flv-video
                            v-if="item.videoType === 2"
                            :dom-id="item.flvUrl + index"
                            :video-obj="item"
                            :autoLogin="resetVideo"
                          /> -->

                          <HelloWorld :puid="item.puid" />
                        </div>
                        <div class="flvVideoButton">
                          <!-- <el-button
                        v-if="callType === 1"
                          class="button2"
                          @click="startcall(item)"
                          type="primary"
                          >开始喊话</el-button
                        >
                        <el-button v-else type="danger" @click="stopPlay('callID', item)">停止喊话</el-button> -->
                          <el-button
                            class="button2"
                            @click="goindIvidualVideo(item)"
                            type="primary"
                            >更多操作</el-button
                          >
                          <!-- <el-button
                            v-if="talkType === 1"
                            class="button2"
                            @click="starttalk(item)"
                            type="primary"
                            >开始对讲 {{ item.puid }}</el-button
                          >
                          <el-button
                            v-else
                            type="danger"
                            @click="stopPlay('talkID', item)"
                            >停止对讲</el-button
                          > -->
                        </div>
                      </div>
                      <!-- <div class="mask" v-else>
                        {{ maskTest }}
                      </div> -->
                    </swiper-slide>
                  </swiper>
                  <div
                    ref="videoRight"
                    slot="button-next"
                    class="swiper-next-1"
                    style=" outline: none; z-index: 999"
                  >
                    <i
                      class="el-icon-arrow-right"
                      style="color: #fff; font-size: 2em; cursor: pointer"
                    />
                  </div>
                </div>
                <div class="flvMask" v-else>
                  {{ maskTest }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col class="table-item tjcon_1" style="width: 20%; color: #00ccff;">
          <div class="modification_tl"></div>
          <div class="modification_tr"></div>
          <div class="modification_br"></div>
          <div class="modRbg"></div>
          <h1 class="unitInfoTitle">
            <span class="dwxxcon_title_1" />
            <span class="context">单位信息</span>
            <span class="dwxxcon_title_3" />
          </h1>
          <div v-if="activeUnit" :model="activeUnit" class="activeUnit">
            <p>
              <span>单位名称：</span><span>{{ activeUnit.unitName }}</span>
            </p>
            <p v-if="activeUnit.unitAddress">
              <span>单位地址：</span><span>{{ activeUnit.unitAddress }}</span>
            </p>
            <p>
              <span>消控室负责人：</span><span>{{ activeUnit.unitUser }}</span>
            </p>
            <p style="margin-bottom: 20px">
              <span>消控室电话：</span><span>{{ activeUnit.unitTel }}</span>
            </p>
            <el-button
              v-if="activeUnit.keyParts"
              @click="
                (dialogTitle = '消防安全重点部位'), openImg(activeUnit.keyParts)
              "
              >消防安全重点部位</el-button
            >
            <el-button
              v-if="activeUnit.unitPlanePic"
              @click="
                (dialogTitle = '消防设施平面布置点'),
                  openImg(activeUnit.unitPlanePic)
              "
              >消防设施平面布置点</el-button
            >
            <el-button
              v-if="activeUnit.unitProgramme"
              @click="
                (dialogTitle = '灭火应急疏散预案'),
                  openImg(activeUnit.unitProgramme)
              "
              >灭火应急疏散预案</el-button
            >
            <el-button
              v-if="activeUnit.unitUnionProtect"
              @click="
                (dialogTitle = '中城卫安保联防点'),
                  openImg(activeUnit.unitUnionProtect)
              "
              >中城卫安保联防点</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row class="bot">
        <el-col :span="8" class="scroll tjcon_1">
          <div class="modification_tl"></div>
          <div class="modification_tr"></div>
          <div class="modification_br"></div>
          <div class="modRbg_2"></div>
          <h1>
            <span class="dwxxcon_title_1" />
            <span class="context">异常消控室</span>
            <span class="dwxxcon_title_3" />
          </h1>
          <div class="scroll-con">
            <div
              class="marquee-list"
              :class="{ 'animate-up': animateUp }"
              @mouseover="selectStyle()"
              @mouseout="outStyle()"
            >
              <div v-for="(item, index) in unitsErro" :key="index">
                <el-popover placement="top-start" width="300" trigger="hover">
                  <div class="info">
                    <p>名称：{{ item.unitName }}</p>
                    <p>地址：{{ item.unitAddress }}</p>
                    <p>负责人：{{ item.unitUser }} {{ item.unitTel }}</p>
                    <p style="color: red">异常原因：{{ item.errorMsg }}</p>
                    <div class="userList">
                      <div
                        class="userList-con"
                        v-for="(user, index) in item.users"
                        :key="index"
                        style="position: relative"
                      >
                        <img
                          :src="user.userpicPath"
                          alt=""
                          style="height: 100px; object-fit: contain"
                        />
                        <p>
                          {{ user.realName
                          }}<i
                            class="el-icon-notebook-2"
                            :class="userClass(user.bookState)"
                          ></i>
                        </p>
                        <!--<p v-if="user.attState !== 0">在岗</p>-->
                        <i
                          class="el-icon-success"
                          :class="userAttState(user.attState)"
                          style="position: absolute; top: 0; right: 0;"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <p slot="reference">
                    <span style="color: #ffc000">{{ item.unitName }}</span>
                    <span style="color: #ffc000">{{ item.errorMsg }}</span>
                  </p>
                </el-popover>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8" class="scroll tjcon_1 tabs">
          <div class="modification_tl"></div>
          <div class="modification_tr"></div>
          <div class="modification_br"></div>
          <div class="modRbg_2"></div>
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane
              label="单位学习综合排名"
              name="first"
              style="height: 100%"
            >
              <p class="flex" style="background-color: #001745; color: #00ccff">
                <span>排名</span><span>单位名称</span><span>总积分</span
                ><span>总时长</span>
              </p>
              <div
                style="height: calc(100% - 20px); overflow-y: hidden; color: #00ccff"
              >
                <div
                  :class="{ 'animate-up': animateUpUnitStudy }"
                  @mouseover="selectStyleUnitStudy()"
                  @mouseout="outStyleUnitStudy()"
                >
                  <p
                    class="flex"
                    v-for="(item, index) in companyData"
                    :key="index"
                    style="opacity: 0.8; color: #00ccff; border-bottom: solid 1px #00ccff;"
                  >
                    <span>{{ item.sortNum }}</span>
                    <span>{{ item.unitName }}</span>
                    <span>{{ item.scoreNum }}</span>
                    <span>{{ item.courseNum }}</span>
                  </p>
                </div>
              </div>
              <!--            <el-table-->
              <!--              height="100%"-->
              <!--              ref="companyData"-->
              <!--              :key="companyDataKey"-->
              <!--              :data="companyData"-->
              <!--              style="width: 100%">-->
              <!--              <el-table-column prop="" label="排名" width="80px">-->
              <!--                <template slot-scope="scope">-->
              <!--                  {{ scope.$index + 1 }}-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <!--              <el-table-column prop="unitName"  label="单位名称">-->
              <!--              </el-table-column>-->
              <!--              <el-table-column prop="scoreNum" label="总积分" sortable>-->
              <!--              </el-table-column>-->
              <!--              <el-table-column prop="courseNum" label="总时长" sortable>-->
              <!--              </el-table-column>-->
              <!--            </el-table>-->
            </el-tab-pane>
            <el-tab-pane
              label="个人学习综合排名"
              name="second"
              style="height: 100%"
            >
              <p class="flex" style="background-color: #001745; color: #00ccff">
                <span>排名</span><span>姓名</span><span>单位</span
                ><span>总积分</span><span>总时长</span>
              </p>
              <div
                style="height: calc(100% - 20px); overflow-y: hidden; color: #00ccff"
              >
                <div
                  :class="{ 'animate-up': animateUpUserStudy }"
                  @mouseover="selectStyleUserStudy()"
                  @mouseout="outStyleUserStudy()"
                >
                  <p
                    class="flex"
                    v-for="(item, index) in personData"
                    :key="index"
                    style="opacity: 0.8; color: #00ccff; border-bottom: solid 1px #00ccff;"
                  >
                    <span>{{ item.userSortNum }}</span>
                    <span>{{ item.userName }}</span>
                    <span
                      style="text-overflow:ellipsis;white-space: nowrap;overflow: hidden;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                      >{{ item.unitName }}</span
                    >
                    <span>{{ item.uesrScoreNum }}</span>
                    <span>{{ item.uesrCourseNum }}</span>
                  </p>
                </div>
              </div>
              <!--            <el-table-->
              <!--              height="100%"-->
              <!--              ref="personData"-->
              <!--              :key="personDataKey"-->
              <!--              :data="personData"-->
              <!--              :row-class-name="tableRowClassName"-->
              <!--              style="width: 100%">-->
              <!--              <el-table-column prop="" label="排名" width="80px">-->
              <!--                <template slot-scope="scope">-->
              <!--                  {{ scope.$index + 1 }}-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <!--              <el-table-column prop="userName"  label="姓名">-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-popover-->
              <!--                    placement="top-start"-->
              <!--                    width="200"-->
              <!--                    trigger="hover">-->
              <!--                    <div class="Userinfo">-->
              <!--                      <img :src='scope.row.userpicPath' alt="">-->
              <!--                      <p>姓名：{{ scope.row.userName }}</p>-->
              <!--                      <p>电话：{{ scope.row.tel }}</p>-->
              <!--                    </div>-->
              <!--                    <span slot="reference">{{ scope.row.userName }}</span>-->
              <!--                  </el-popover>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <!--              <el-table-column prop="uesrScoreNum" label="总积分" sortable>-->
              <!--              </el-table-column>-->
              <!--              <el-table-column prop="uesrCourseNum" label="总时长" sortable>-->
              <!--              </el-table-column>-->
              <!--            </el-table>-->
            </el-tab-pane>
          </el-tabs>
          <!--        <h1>正常消控室</h1>-->
          <!--        <div class="scroll-con">-->
          <!--          <div class="marquee-list" :class="{'animate-up': animateUp}" @mouseover="selectStyle2()" @mouseout="outStyle2()">-->
          <!--            <div v-for="(item, index) in units" :key="index">-->
          <!--              <el-popover placement="top-start" width="300" trigger="hover">-->
          <!--                <div class="info">-->
          <!--                  <p>名称：{{ item.unitName }}</p>-->
          <!--                  <p>地址：{{ item.unitAddress }}</p>-->
          <!--                  <p>负责人：{{ item.unitUser }} {{ item.unitTel }}</p>-->
          <!--                  <div class="userList">-->
          <!--                    <div class="userList-con" v-for="(user, index) in item.users" :key="index">-->
          <!--                      <img :src='user.userpicPath' alt="">-->
          <!--                      <p>{{ user.realName }}<i class="el-icon-notebook-2" :class="userClass(user.bookState)"></i></p>-->
          <!--                      <p v-if="user.attState !== 0">在岗</p>-->
          <!--                    </div>-->
          <!--                  </div>-->
          <!--                </div>-->
          <!--                <el-button slot="reference" style="overflow: hidden; width: 100%; display: block">{{ item.unitName }}</el-button>-->
          <!--              </el-popover>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
        </el-col>
        <el-col :span="8" class="chart tjcon_1">
          <div class="modification_tl"></div>
          <div class="modification_tr"></div>
          <div class="modification_br"></div>
          <div class="modRbg_2"></div>
          <div class="content">
            <div class="pic">
              <h1>初/中/高级证书占比</h1>
              <ve-ring
                :data="levelData"
                :extend="chartLevel"
                width="100%"
                height="100%"
              ></ve-ring>
            </div>
            <!-- <div class="pic">
            <h1>人员配备占比</h1>
            <ve-pie :data="equipData" :extend="chartEquip" width="100%" height="100%"></ve-pie>
          </div> -->
            <div class="pic">
              <h1>今日学习完成率</h1>
              <ve-gauge
                :data="studyData"
                :settings="chartStudySettings"
                width="100%"
                height="100%"
              ></ve-gauge>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
        <div style="width: 100%; height: 500px; overflow-y: scroll;">
          <img
            :src="openUrl"
            alt=""
            style="max-width: 100%; display: block; margin: 0 auto"
          />
        </div>
      </el-dialog>
    </div>

    <!-- 报警弹框 -->
    <div
      v-if="isShowModal"
      class="modal flex flex-justify-center flex-align-center"
    >
      <div class="modalMain flex flex-v">
        <div class="modalTitle flex flex-justify-between">
          <div>报警信息</div>
          <!-- 关闭按钮icon -->
          <i class="el-icon-close" @click="closeFunc" />
        </div>
        <div class="modalCon flex-1 flex flex-v flex-align-center">
          <div class="msg">{{ mqttObj.ruleIdList || "" }}</div>
          <div class="image">
            <img :src="mqttObj.url" />
          </div>
        </div>
        <!-- 操作按钮 -->
        <!-- <div class="flex flex-justify-end">
          <div class="btn" @click="(isShowModal = false)">确定</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import VideoItem from './video'
import countTo from 'vue-count-to'
import webcu2plugin from 'webcu2plugin'
import cf from '@/utils/JLYconfig'
import flvVideo from './flvVideo'
import mqtt from 'mqtt'
import HelloWorld from './login/HelloWorld.vue'
export default {
  name: 'Data',
  components: {
    VideoItem,
    countTo,
    flvVideo,
    HelloWorld
  },
  data () {
    this.chartStudySettings = {
      dataType: {
        完成率: 'percent'
      },
      seriesMap: {
        完成率: {
          min: 0,
          max: 1,
          radius: '85%',
          center: ['50%', '55%'],
          pointer: {
            length: '60%',
            width: 5
          },
          axisLabel: {
            fontSize: 10
          },
          splitLine: {
            length: 15
          },
          axisLine: {
            lineStyle: {
              width: 15,
              color: [
                [0.25, 'red'],
                [0.5, 'orange'],
                [0.75, 'green'],
                [1, 'blue']
              ]
            }
          },
          splitNumber: 4,
          detail: {
            fontSize: 16,
            fontWeight: 'bolder'
          }
        }
      }
    }
    this.chartLevel = {
      legend: {
        show: false
      },
      series: {
        z: 2,
        left: 0,
        top: 20,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '90%',
        center: ['55%', '50%'],
        radius: ['35%', '55%']
      },
      tooltip: {
        formatter: '{b}: {c}个，占比{d}%'
      }
    }
    this.chartEquip = {
      legend: {
        show: false
      },
      series: {
        z: 2,
        left: 0,
        top: 20,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        center: ['50%', '50%'],
        radius: [0, '60%']
      },
      tooltip: {
        formatter: '{b}配备: {c}家公司,占比{d}%'
      },
      grid: {
        top: 0,
        bottom: 50,
        left: 0,
        right: 0
      }
    }
    return {
      playerList: [],
      callType: 1,
      talkType: 1,
      videoWindowObj: {},
      devOnlineFlag: true,
      maskTest: '暂无数据',
      flagflv: true,
      currentOption: 'live', // 默认选中实时视频
      camareList: [],
      swiperOption1: {
        slidesPerView: 1,
        spaceBetween: 40,
        // width: '100%',
        // height: '100%',
        direction: 'horizontal',
        navigation: {
          nextEl: '.swiper-next-1',
          prevEl: '.swiper-prev-1'
        }
      },
      flag: false,
      certificate: null,
      barOption: {
        color: ['#00ccff'],
        textStyle: {
          color: '#00ccff'
        },
        title: {
          text: '一周消控室合格率',
          textStyle: {
            color: '#00ccff',
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: '#0776ab'
            }
          },
          axisLabel: {
            interval: 0
            // rotate: -90
          },
          splitLine: {
            lineStyle: {
              color: ['#0776ab']
            }
          }
        },
        yAxis: {
          type: 'value',
          // boundaryGap: [0, 1],
          textStyle: {
            fontSize: 10
          },
          axisLine: {
            lineStyle: {
              color: '#0776ab'
            }
          },
          axisLabel: {
            formatter: function (value) {
              return value + '%'
            }
          }
        },
        series: [
          {
            type: 'bar',
            data: [18203, 23489, 29034, 104970, 131744, 630230]
          }
        ]
      },
      chartExtendLine: {
        'xAxis.0.axisLabel.color': '#888888', // x轴文本颜色
        'yAxis.0.axisLabel.color': '#888888' // y轴文本改变颜色
      },
      chartSettingsLine: {},
      chartDataLine: {
        columns: ['日期', '正常', '异常'],
        rows: [
          { 日期: '1/1', 正常: 1393, 异常: 1093 },
          { 日期: '1/2', 正常: 3530, 异常: 3230 },
          { 日期: '1/3', 正常: 2923, 异常: 2623 },
          { 日期: '1/4', 正常: 1723, 异常: 1423 },
          { 日期: '1/5', 正常: 3792, 异常: 3492 },
          { 日期: '1/6', 正常: 4593, 异常: 4293 }
        ]
      },
      dialogTitle: '',
      unitId: '',
      allUnits: [],
      activeItemTimer: null,
      openUrl: '',
      dialogVisible: false,
      activeUnit: null,
      nowIndex: 0,
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 2,
        slidesPerColumn: 1,
        spaceBetween: 40,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      },
      videoList: [],
      activeName: 'first',
      unitsErro: [],
      units: [],
      expired: 0,
      errUnit: 0,
      animateUp: false,
      animateUpUnitStudy: false,
      animateUpUserStudy: false,
      animateUp2: false,
      animateUnitsUp: false,
      timer: null,
      lists: [
        {
          time: '2020-09-14 14:12:20',
          text:
            '这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据这是一条测试数据'
        },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' },
        { time: '2020-09-14 14:12:20', text: '这是一条测试数据' }
      ],
      studyData: {
        columns: ['type', 'value'],
        rows: [{ type: '完成率', value: 0.8 }]
      },
      levelData: {
        columns: ['name', 'val'],
        rows: [
          { name: '初级', val: 1393 },
          { name: '中级', val: 3530 },
          { name: '高级', val: 2923 }
        ]
      },
      levelDataNormalEquip: {
        data: [
          { name: '正常', value: 10 },
          { name: '异常', value: 10 }
        ]
      },
      normalWater: {
        data: [66]
      },
      equipData: {
        columns: ['key', 'vel'],
        rows: [
          { key: '1/2', vel: 3530 },
          { key: '1/3', vel: 2923 },
          { key: '1/4', vel: 1723 },
          { key: '1/5', vel: 3792 },
          { key: '1/6', vel: 4593 }
        ]
      },
      companyDataKey: 0,
      personDataKey: 0,
      companyData: [],
      personData: [],
      box: {
        dutyNum: 0,
        errUnit: '',
        expired: '',
        licensed: 0,
        qingJia: '',
        queQin: '',
        sign: 0,
        units: 0
      },
      date: new Date(),
      boxes: [],
      rightTimes: 0,
      activeVideo: null,
      activeVideoIndex: '',
      mtopic: 'topic/xaskp',
      client: {},
      // 是否展示报警弹框
      isShowModal: false,
      // 报警信息
      mqttObj: {},
      setTimeoutFunc: null,
      // 异常数
      abnormalNum: 0,
      // 预警报告数据列表
      warningReportList: []
    }
  },
  created () {
    window.WIDGET = {
      CONFIG: {
        modules: '102',
        background: 5,
        tmpColor: '409EFF',
        tmpSize: 16,
        cityColor: '409EFF',
        citySize: 16,
        aqiSize: 16,
        weatherIconSize: 24,
        alertIconSize: 18,
        padding: '10px 10px 10px 10px',
        shadow: '1',
        language: 'auto',
        borderRadius: 5,
        city: 'CN101110101',
        fixed: 'false',
        vertical: 'middle',
        horizontal: 'right',
        key: 'kHOK3Klres'
      }
    };
    (function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href =
        'https://apip.weatherdt.com/simple/static/css/weather-simple.css?v=2.0'
      var s = d.createElement('script')
      s.src =
        'https://apip.weatherdt.com/simple/static/js/weather-simple.js?v=2.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  mounted () {
    // 获取异常数
    this.initData()
    // this.autoLogin()
    console.log('mounted-=---------')
    this.createConnection()
    this.getCertificate()
    // this.getWeekNormalRate()
    // 获取预警报告
    this.getWarningReport()
    // this.getLine()
    this.getUnits()
    this.getVideoList()
    this.fetchUnit()
    this.fetchMsg()
    this.timerScroll = setInterval(this.scrollAnimate, 1500)
    this.timerScrollUnitStudy = setInterval(this.scrollAnimateUnitStudy, 3000)
    this.timerUnit = setInterval(this.fetchUnit, 300000)
    this.timerMsg = setInterval(this.fetchMsg, 300000)
    this.fetch()
    let _this = this
    this.timer = setInterval(function () {
      _this.date = new Date().toLocaleString()
    })
    // 每隔十五秒切换视频
    this.activeItemTimer = setInterval(() => {
      console.log('-----------', this.videoList)
      if (this.videoList.length > 1) {
        for (let i = 0; i < this.videoList.length; i++) {
          if (this.activeUnit.videoId === this.videoList[i].id) {
            if (i === this.videoList.length - 1) {
              this.getUnitInfo(this.videoList[0])
              this.nowIndex = 0
              this.leftClick()
              this.activeVideo = null
              this.$nextTick(() => {
                this.activeVideo = this.videoList[0]
              })
            } else {
              if (i + 1 >= 2) {
                this.$refs.videoRight.click()
                this.rightTimes = this.rightTimes + 1
              }
              this.getUnitInfo(this.videoList[i + 1])
              this.activeVideo = null
              this.$nextTick(() => {
                this.activeVideo = this.videoList[i + 1]
              })
              this.nowIndex++
            }
          }
        }
      }
    }, 60000)
  },
  watch: {
    '$store.state.account.ythItem' () {
      console.log('store.state.account.ythItem')
      this.getUser()
      this.getCamare()
      // this.autoLogin()
      this.getEmpSigns()
      this.getMarkers()
      this.getCaptainList()
      this.getDeviceNum()
      this.mapCenter = [
        Number(this.$store.state.account.ythItem.longitude),
        Number(this.$store.state.account.ythItem.latitude)
      ]
      this.risk = this.$store.state.account.ythItem.itemFxUrl
      this.vr = this.$store.state.account.ythItem.vrUrl
      this.obj = this.$store.state.account.ythItem
    }
  },
  methods: {
    goindIvidualVideo (item) {
      this.$router.push({
        path: '/individualVideo',
        query: { puid: item.puid }
      })
    },
    async handleStartAudio (enable) {
      const playerItem = this.videoWindowObj
      if (!playerItem) return
      const params = { playID: playerItem.playID, enable, token: this.token }
      const data = await webcu2plugin.enablePlayAudio(params)
      if (data.msg === 'OK') {
        // this.$message.success(enable === 1 ? '已启动伴音~' : '已关闭伴音~')
      }
    },
    async starttalk (item) {
      console.log('item', item)
      this.talkType = 2
      this.$forceUpdate()
      this.videoWindowObj = item
      const playerItem = this.videoWindowObj
      if (!playerItem) return
      const puid = playerItem.puid
      const token = playerItem.token
      const params = { puid, token }
      const data = await webcu2plugin.startTalk(params)
      if (!data && !data.playID) return
      playerItem.talkID = data.playID
      console.log(data.playID, '对讲')
      this.$message.success('已启动对讲')
    },
    async startcall (item) {
      console.log(item, 1111)
      this.callType = 2
      this.videoWindowObj = item
      this.$forceUpdate()
      const playerItem = this.videoWindowObj
      if (!playerItem) return
      const puid = playerItem.puid
      const token = playerItem.token
      const params = { puid, token }
      const data = await webcu2plugin.startCall(params)
      if (!data && !data.playID) return
      playerItem.callID = data.playID
      console.log(data.playID, '喊话')

      this.handleStartAudio(1)
      this.$message.success('已启动喊话')
    },
    async stopPlay (type, item) {
      if (type === 'callID') {
        this.callType = 1
      } else {
        this.talkType = 1
      }
      this.$forceUpdate()
      const playerItem = this.videoWindowObj
      if (!playerItem) return
      const token = playerItem.token
      // console.log('playerItem[type]', playerItem[type])
      console.log(playerItem, '++++++++++++++++++++++')
      // console.log(playerItem.callID, '++++++++++++++++++++++callID')
      console.log(item.callID, '++++++++++++++++++++++callIDitem')
      // console.log(playerItem.talkID, '++++++++++++++++++++++talkID')
      console.log(item.talkID, '++++++++++++++++++++++talkIDitem')
      let playID = ''
      if (type === 'callID') {
        playID = String(item.callID)
      } else {
        playID = String(item.talkID)
      }
      const params = { id: playID, token: token }
      console.log('params____________________', params)
      this.handleStartAudio(0)
      const data = await webcu2plugin.stoptStream(params)
      console.log('paramsparams2____________________', params)
      console.log(data.msg, '_______________________________')
      if (data.msg === 'OK') {
        // playerItem[type] = ''
        this.$message.success('已停止')
      } else {
        this.$message.success('未停止')
      }
    },

    // 获取当前操作元素
    getPlayerItem () {
      let playerItem = null
      this.playerList.forEach((item, index) => {
        if (item.windowIndex === this.currentWindowIndex) {
          playerItem = item
        }
      })
      if (playerItem && playerItem.jessibuca) {
        return playerItem
      } else {
        this.$message.error('请选择需要操作的视频~')
        return false
      }
    },
    // 停止播放，停止喊话，停止对讲
    // async stopPlay (type) {
    //   let playerItem = this.getPlayerItem()
    //   if (!playerItem || !playerItem[type]) return
    //   let params = {
    //     id: playerItem[type],
    //     token: this.token
    //   }
    //   let data = await webcu2plugin.stoptStream(params)
    //   if (data.msg === 'OK') {
    //     // playerItem[type] = ''
    //     this.$message.success('已停止')
    //     this.talkType = 2
    //   } else {
    //     this.$message.success('未停止')
    //   }
    //   // 先通知插件关闭流再前端关闭播放器,前端直接关闭播放器,插件也会断开流
    //   if (type === 'playID') {
    //     playerItem.jessibuca.destroy()
    //     this.playerList = this.playerList.filter((item) => {
    //       return item.playID !== playerItem.playID
    //     })
    //   }
    // },
    async changeVideo (option) {
      if (option !== this.currentOption) {
        this.currentOption = option
        this.flag = !this.flag
      }

      if (option === 'soldier') {
        await this.getDeviceList()
      }
    },
    goPoliceProtectionLinkage () {
      const loginInfo = 'Launch.exe --address=61.185.238.249 --port=9988 --nmcport=9583 --user=XFPT --password=123456 --fixaddress'
      const base64Url = btoa(loginInfo)
      console.log(`icvsapp://${base64Url}`)
      window.open(`icvsapp://${base64Url}`)
    },
    resetVideo () {
      this.camareList = []
      this.autoLogin()
    },
    async autoLogin () {
      const callback = params => {
        // 视频播放状态
        if (params.type === 'PlayEvent') {
          console.log(params)
        }
      }
      const params = {
        address: cf.connParams.address,
        port: cf.connParams.port,
        user: cf.connParams.user,
        password: cf.connParams.password,
        epid: cf.connParams.epid,
        fixaddr: cf.connParams.bfix
      }
      console.log('params', params)
      const data = await webcu2plugin.login(params, callback)
      console.log(data)
      if (data && data.msg === 'OK') {
        this.token = data.token
        // localStorage.setItem('flvToken', data.token)
        // let device = []
        // this.fetch_device(0, 200, device)
        // console.log(this.token, '++++++++++++++++++++++')
        await this.getDeviceList()
      } else {
        console.log('连接异常（网络超时，未安装插件）')
        // this.$message.error('执法记录仪，连接异常（网络超时，未安装插件）')
        this.flagflv = false
        this.maskTest =
          '因未安装插件，无法连接单兵视频，请联系管理员安装插件后重试！'
      }
    },
    // 获取设备列表
    // async fetch_device (offset, count, device) {
    //   let params = {
    //     offset: offset,
    //     count: count,
    //     token: this.token
    //   }
    //   const data = await webcu2plugin.getDeviceList(params)
    //   if (data instanceof Array) {
    //     device = device.concat(data)
    //     if (data.length === count) {
    //       offset += count
    //       this.fetch_device(offset, count, device)
    //     } else {
    //       // 加载在线设备
    //       // let deviceList = new Array()
    //       let deviceList = []
    //       for (let i = 0; i < device.length; i++) {
    //         let deviceItem = device[i]
    //         // if (deviceItem.OnlineFlag === '1' && deviceItem.Type != 'DEC') {
    //         if (deviceItem.OnlineFlag === '1') {
    //           deviceList.push({
    //             ...deviceItem,
    //             puid: deviceItem.$,
    //             id: deviceItem.$,
    //             name: deviceItem.Name,
    //             onlineFlag: true,
    //             type: deviceItem.Type,
    //             children: []
    //           })
    //         }
    //       }
    //       deviceList.sort((a, b) => {
    //         return b.OnlineFlag - a.OnlineFlag
    //       })
    //       // console.log(deviceList);
    //       this.deviceList = deviceList
    //     }
    //   } else {
    //     console.log('获取设备列表失败')
    //   }
    // },
    // 这里修改
    async getDeviceList (params = {}) {
      params.pageSize = 999
      params.pageNum = 1
      params.unitId = this.unitId
      this.$get('/recorder', { ...params }).then(async res => {
        const data = res.data.data
        console.log(res.data, '==========')
        if (Object.keys(res.data).length === 0) {
          // 如果 data 是空对象，执行暂停代码的逻辑
          // 暂停代码逻辑...
          console.log('没有数据')
          this.flagflv = false
          this.maskTest = '暂无数据'
          // 返回，不再执行下面的代码
        } else {
          this.flagflv = true
          this.camareList = []
          data.forEach(item => {
            this.camareList.push({ puid: item.recorderCode })
          })
        }
      })
    },
    // 获取异常数
    initData () {
      this.$get('/equipEvent/findEquipEventBigScreen').then(res => {
        res = res.data
        if (res.code === 200) {
          this.abnormalNum = res.data
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    createConnection () {
      // 连接字符串, 通过协议指定使用的连接方式
      // ws 未加密 WebSocket 连接
      // wss 加密 WebSocket 连接
      // mqtt 未加密 TCP 连接
      // mqtts 加密 TCP 连接
      // wxs 微信小程序连接
      // alis 支付宝小程序连接
      const num = Math.random(1000)
      this.client = mqtt.connect('wss://mqtt.atx.net.cn:8085/mqtt', {
        // this.client = mqtt.connect('wss://47.92.77.75:2883/mqtt', {
        // 认证信息
        clientId: `web_mqtt${num}`,
        clean: true // 保留会话
      })
      this.client.on('connect', e => {
        console.log('连接成功')
        this.client.subscribe(this.mtopic, err => {
          if (!err) {
            console.log('订阅成功:' + this.mtopic)
            // this.client.publish('topic/sun', '好的好的')
          }
        })
      })
      this.client.on('message', (topic, res) => {
        const utf8decoder = new TextDecoder()
        // const data = JSON.parse(utf8decoder.decode(res))
        let data = utf8decoder.decode(res)
        data = JSON.parse(data)
        this.mqttObj = data.data
        this.isShowModal = true
        clearTimeout(this.setTimeoutFunc)
        // this.dataObj = JSON.parse(JSON.stringify(obj))
        this.isShowModal = true
        this.setTimeoutFunc = setTimeout(() => {
          this.isShowModal = false
        }, 10000)
        console.log(
          '报警数据信息：',
          data,
          '==================================='
        )
      })

      // setInterval(() => {
      //   this.client.publish('topic/sun', '好的好的')
      // }, 1000)
    },
    // 关闭报警弹框
    closeFunc () {
      clearTimeout(this.setTimeoutFunc)
      this.isShowModal = false
    },
    getCertificate () {
      this.$get('userCertificate/findReviewUserList').then(r => {
        console.log(r)
        if (r.data.code === 200) {
          this.certificate = r.data.data
        }
      })
    },
    getWeekNormalRate () {
      this.barOption.yAxis.data = []
      this.barOption.series[0].data = []
      this.$get('/unit/getWeekNormalRate').then(r => {
        console.log('一周消控室合格率', r)
        if (r.data.code === 200) {
          const arr = r.data.data
          if (arr.length) {
            arr.forEach((i, index) => {
              if (!(index % 2)) {
                this.barOption.xAxis.data.push(
                  i.dateTime ? i.dateTime.slice(5) : ''
                )
                this.barOption.series[0].data.push(
                  Number(i.normalRateVo || 0) * 100
                )
              }
            })
            var myChart = this.$echarts.init(document.getElementById('bar'))
            myChart.setOption(this.barOption)
          }
        }
      })
    },
    // 获取预警报告
    getWarningReport () {
      this.$get('/maintenanceContract/getMaintenanceContract').then(res => {
        res = res.data
        if (res.code === 200) {
          this.warningReportList = res.data
        }
      })
    },
    // getLine () {
    //   this.$get().then()
    // },
    userAttState (e) {
      switch (e) {
        case 0:
          return 'erro'
        case 1:
          return 'normal'
      }
    },
    leftClick () {
      if (this.rightTimes > 0) {
        this.$refs.videoLeft.click()
        this.rightTimes--
        this.leftClick()
      }
    },
    selectChange (value) {
      setInterval(this.activeItemTimer)
      this.changeVideo('live')
      this.$get('camera/getList?unitId=' + value).then(res => {
        if (res.data.data) {
          // this.autoLogin()
          this.camareList = []
          this.videoList = []
          this.activeVideo = null
          this.$nextTick(() => {
            this.videoList = res.data.data
            this.getUnitInfo(this.videoList[0])
            this.activeVideo = this.videoList[0]
          })
        } else {
          this.videoList = []
          this.activeUnit = null
          this.activeVideo = null
        }
        this.nowIndex = 0
        this.rightTimes = 0
      })
    },
    getUnits () {
      this.$get('unit/getUnitList').then(r => {
        const data = r.data
        this.allUnits = data.data
      })
    },
    openImg (e) {
      this.dialogVisible = true
      this.openUrl = e
    },
    videoClick (item, index) {
      clearInterval(this.activeItemTimer)
      this.nowIndex = index
      this.getUnitInfo(item)
      this.activeVideo = null
      this.$nextTick(() => {
        this.activeVideo = item
      })
    },
    // 根据消控室ID获取消控室信息
    getUnitInfo (item) {
      this.$get('unit/getInfoById/' + item.unitId).then(r => {
        if (r.data.code === 200) {
          this.activeUnit = r.data.data
          this.activeUnit.videoId = item.id
          if (
            item.vrPath !== undefined &&
            item.vrPath !== null &&
            item.vrPath !== ''
          ) {
            this.activeUnit.vrPath = item.vrPath
          }
        }
      })
    },
    toVr (e) {
      if (e !== undefined && e !== null && e !== '') {
        window.open(e)
      } else {
        this.$message.warn('该项目暂无VR')
      }
    },
    getVideoList () {
      this.$get('camera/getList').then(res => {
        this.videoList = res.data.data
        this.getUnitInfo(this.videoList[0])
        this.activeVideo = this.videoList[0]
        this.unitId = this.videoList[0].unitId
      })
    },
    handleClick (tab) {
      if (tab.label === '个人学习综合排名') {
        clearInterval(this.timerScrollUnitStudy)
        this.timerScrollUserStudy = setInterval(
          this.scrollAnimateUserStudy,
          3000
        )
      } else {
        clearInterval(this.timerScrollUserStudy)
        this.timerScrollUnitStudy = setInterval(
          this.scrollAnimateUnitStudy,
          3000
        )
      }
    },
    userClass (e) {
      switch (e) {
        case '0':
          return 'black'
        default:
          return 'green'
      }
    },
    selectStyle () {
      this.animateUp = false
      clearInterval(this.timerScroll)
    },
    selectStyleUnitStudy () {
      this.animateUpUnitStudy = false
      clearInterval(this.timerScrollUnitStudy)
    },
    selectStyleUserStudy () {
      this.animateUpUserStudy = false
      clearInterval(this.timerScrollUserStudy)
    },
    outStyle () {
      this.animateUp = true
      this.timerScroll = setInterval(this.scrollAnimate, 1500)
    },
    outStyleUnitStudy () {
      this.animateUpUnitStudy = true
      this.timerScrollUnitStudy = setInterval(
        this.scrollAnimateUnitStudy,
        1500
      )
    },
    outStyleUserStudy () {
      this.animateUpUserStudy = true
      this.timerScrollUserStudy = setInterval(
        this.scrollAnimateUserStudy,
        1500
      )
    },
    selectStyleUnits () {
      this.animateUnitsUp = false
      clearInterval(this.timerScrollUnits)
    },
    scrollAnimateUnitStudy () {
      this.animateUpUnitStudy = true
      setTimeout(() => {
        this.companyData.push(this.companyData[0])
        this.companyData.shift()
        this.animateUpUnitStudy = false
      }, 500)
    },
    scrollAnimateUserStudy () {
      this.animateUpUserStudy = true
      setTimeout(() => {
        this.personData.push(this.personData[0])
        this.personData.shift()
        this.animateUpUserStudy = false
      }, 500)
    },
    scrollAnimate () {
      this.animateUp = true
      setTimeout(() => {
        this.unitsErro.push(this.unitsErro[0])
        this.unitsErro.shift()
        this.animateUp = false
      }, 500)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      }
      return ''
    },
    initBox () {
      return {
        dutyNum: 0,
        errUnit: '',
        expired: '',
        licensed: 0,
        qingJia: '',
        queQin: '',
        sign: 0,
        units: 0
      }
    },
    fetch () {
      this.$get(`unit/units`).then(r => {
        const data = r.data
        this.box = data
        console.log(data)
        const arr = []
        arr.push({ type: '完成率', value: data.courseToday })
        this.studyData.rows = arr
        this.levelData.rows = data.certificate
        this.levelDataNormalEquip = {
          data: [
            { name: '正常', value: this.box.units - this.unitsErro.length },
            { name: '异常', value: this.unitsErro.length }
          ],
          digitalFlopStyle: {
            fontSize: 25,
            fill: '#00ccff',
            color: '#00ccff'
          }
        }
        this.normalWater = {
          data: [
            ((1 - this.unitsErro.length / this.box.units) * 100).toFixed(2)
          ]
        }
      })
      this.$get(`unit/monitors`).then(r => {
        const data = r.data
        this.companyData = data.jsonArray
        this.personData = data.userJsonArray
        for (let i = 0; i < data.percentageArray.length; i++) {
          data.percentageArray[i].key = data.percentageArray[i].key + '人'
        }
        this.equipData.rows = data.percentageArray
      })
    },
    fetchUnit () {
      this.$get('unit/erroUnits').then(r => {
        const data = r.data
        this.errUnit = data.errUnit
        this.expired = data.expired
        const MonitorsUnits = data.monitorsUnits
        const arr = []
        const arrErro = []
        for (let i = 0; i < MonitorsUnits.length; i++) {
          if (MonitorsUnits[i].isEro === '0') {
            arr.push(MonitorsUnits[i])
          } else {
            arrErro.push(MonitorsUnits[i])
          }
        }
        this.unitsErro = arrErro
        this.units = arr
      })
    },
    fetchMsg () {
      this.$get('real').then(r => {
        this.lists = r.data.data
        this.$get('unit/erroUnits').then(res => {
          for (let i = 0; i < res.data.reals.length; i++) {
            this.lists.push(res.data.reals[i])
          }
        })
      })
    }
  },
  destroyed () {
    console.log('destroyed......')
    clearInterval(this.activeItemTimer)
    clearInterval(this.timerScroll)
    clearInterval(this.timerUnit)
    clearInterval(this.timerMsg)
    clearInterval(this.timerScrollUnitStudy)
    clearInterval(this.timerScrollUserStudy)
  },
  beforeDestroy: function () {
    console.log('beforeDestroy......')
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="less">
.el-select-dropdown {
  background-color: #001048;
  border: solid 1px #0170ad;

  .el-select-dropdown__item.selected {
    background-color: #21c6e3;
    color: #fff;
  }

  .el-select-dropdown__item.hover {
    background-color: #21c6e3;
    color: #fff;
  }

  .el-select-dropdown__item {
    color: #00ccff;
  }
}

.dataScreen {
  .el-dialog {
    background: url("/static/img/ybdsbg2.png") repeat;

    .el-dialog__header {
      border-bottom: solid 1px #0c9cc1;

      .el-dialog__title {
        color: #01a5dd;
        font-size: 14px;
      }
    }
  }

  .unitSelect {
    .el-input {
      background: none;

      .el-input__inner {
        color: #00ccff;
        background: none;
        border: solid 1px #0170ad;
      }
    }
  }

  .tabs {
    .el-tabs--card {
      .el-tabs__header {
        border: none;
      }
    }

    .el-tabs__nav {
      .is-active {
        background: url("/static/img/ybdsbg.png") repeat !important;
        color: #00ccff;
      }

      .el-tabs__item {
        background: none;
        color: #00ccff;
        border-bottom: solid 1px #0776ab;
      }

      .el-tabs__item:last-child {
        border-left: solid 1px #0776ab !important;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.normal {
  color: green;
}

.warn {
  color: orange;
}

.erro {
  color: red;
}

@font-face {
  font-family: yjsz;
  src: url("/static/img/yjsz.TTF");
}

.video-item {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  color: #ffffff;

  .video-title {
    height: 50px;
    line-height: 50px;
    padding: 0 1.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #051d3f;
    cursor: pointer;
    .video-title-name {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;
        margin-left: 20px;
        border-radius: 10px;
        background-color: #00bb00;
      }
    }
    .oneline {
      width: 100px; /* 可根据需要调整宽度 */
      white-space: nowrap; /* 防止换行 */
      overflow: hidden; /* 控制溢出隐藏 */
      text-overflow: ellipsis; /* 使用省略号代替 */
    }
    .video-title-status {
      display: flex;
      align-items: center;
      .selected {
        color: #fff;
      }

      // i {
      //   display: inline-block;
      //   width: 1.25rem;
      //   height: 1.25rem;
      //   border-radius: 10px;
      //   background-color: #00bb00;
      // }

      span {
        padding-left: 10px;
        color: #237dbf;
      }
    }
  }

  .video-content-content {
    height: calc(100% - 50px);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #082c61;
    .videoBox {
      width: 100%;
      height: 100%;
      .flvBox {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .swiper {
          .swiperSlideItem {
            width: 100%;
            height: 85%;
            .flvVideoBox {
              width: 100%;
              height: 100%;
            }
            .flvVideoButton {
              width: 100%;
              height: 15%;
              display: flex;
              justify-content: flex-end;
              align-items: center;
            }
          }
          .mask {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .swiper-container {
          width: 100%;
          height: 100%;
          .swiper-slide.swiper-slide-active {
            width: 100%;
            height: 100%;
          }
        }
      }
      .flvMask {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.animate-up {
  transition: all 0.5s ease-in-out;
  transform: translateY(-40px);
}

.mainCon {
  .flex {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #fff;
    margin-bottom: 0;
    height: 40px;
    line-height: 40px;

    span {
      text-align: center;
      width: 25%;
      display: block;
    }

    span:nth-child(2) {
      width: 40%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span:first-child {
      width: 15%;
    }

    span:last-child {
      width: 20%;
    }
  }
}

.activeUnit {
  color: #00ccff;
  margin-top: 30px;

  p {
    width: 100%;
    display: flex;
    justify-content: space-between;

    span:first-child {
      width: 38%;
    }

    span:last-child {
      width: 60%;
      text-align: right;
    }
  }

  .el-button {
    background-color: #1e9fff;
    border: none;
    color: #fff;
    width: 100%;
    margin-bottom: 20px;
    margin-left: 0;
  }
}

.videoActive {
  box-shadow: 0 0 10px #00c2ff;
  -webkit-box-shadow: 0 0 10px #00c2ff;
}

/deep/ .el-tabs {
  height: 100%;
}

/deep/ .el-tabs__content {
  height: calc(100% - 56px) !important;
  width: 96%;
  margin: 0 auto;
}

/deep/ .el-tabs__nav {
  width: 100%;
  border: none !important;

  .el-tabs__item {
    width: 50%;
    text-align: center;
    color: #fff;
    background-color: #36baff;
    border-left: none !important;
  }

  .is-active {
    color: #444;
    background-color: #e7e7e7;
  }
}

.info {
  width: 100%;

  p {
    margin-bottom: 5px;
  }

  .userList {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .userList-con {
      width: 32%;
      position: relative;

      p {
        width: 100%;
        text-align: center;
      }

      img {
        display: block;
        width: 100%;
      }

      i {
        /*position: absolute;*/
        /*top: 2px;*/
        /*right: 2px;*/
        width: 16px;
        height: 16px;
      }

      .black {
        color: black;
      }

      .green {
        color: green;
      }
    }
  }
}

.Userinfo {
  width: 100%;

  p {
    margin-bottom: 5px;
    width: 100%;
    text-align: center;
  }

  img {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
}

.bg {
  width: 100%;
  height: 100%;
  background: url("/static/img/bg.jpg") center bottom no-repeat;
  color: #00ccff;
  background-size: 100% 100%;

  .head {
    position: relative;
    height: 100px;
    width: 100%;
    background: url("/static/img/GF_topbg.png") bottom center no-repeat;
    display: flex;
    justify-content: center;

    // background-color: #010853;
    h1 {
      font-weight: bold;
      color: #00ccff;
      line-height: 100px;
      width: 30%;
      text-align: center;
    }

    .title-left {
      width: 20%;
      height: 70px;
      background: url("/static/img/GF_02.png") no-repeat left;
      background-size: 100% 100%;
    }

    .title-right {
      width: 20%;
      height: 70px;
      background: url("/static/img/GF_03.png") no-repeat left;
      background-size: 100% 100%;
    }

    .time {
      text-align: right;
      position: absolute;
      width: 180px;
      top: 30px;
      right: 150px;
      color: #409eff;
      z-index: 999;
    }

    .button1 {
      position: absolute;
      right: 130px;
      top: 10px;
      cursor: pointer;
    }

    .button2 {
      position: absolute;
      right: 20px;
      top: 10px;
      cursor: pointer;
    }
  }

  .box {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .con {
      padding: 10px;
      border-radius: 10px;

      div {
        height: 160px;
        padding: 0 10px;
        color: #fff;
        position: relative;

        p {
          position: absolute;
          font-size: 1.2em;
          width: 100%;
          left: 0;
          bottom: 10px;
          margin-bottom: 0;
        }

        span {
          font-family: "yjsz";
          font-size: 46px;
          color: #20dbfd;
          text-shadow: 0 0 25px #00d8ff;
          position: absolute;
          left: 0;
          top: 10%;
          display: block;
          width: 100%;
          text-align: center;
        }
      }
    }

    .conFirst {
      display: flex;
      justify-content: space-between;
      width: 99%;

      // box-shadow: 0 0 5px #00c2ff;
      // -webkit-box-shadow: 0 0 5px #00c2ff;
      .smallBox {
        width: 15%;
        background: url("/static/img/GF_moddate.png") no-repeat center;
      }
    }

    .conSecond {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      width: 66%;
      box-shadow: 0 0 5px #00c2ff;
      -webkit-box-shadow: 0 0 5px #00c2ff;

      div {
        width: 21%;
      }
    }
  }

  .table {
    margin-top: 30px;
    height: calc(50% - 70px);
    padding: 0 0.5%;

    .table-item {
      height: 100%;
      // border-radius: 10px;
      // box-shadow: 0 0 5px #00c2ff;
      // -webkit-box-shadow: 0 0 5px #00c2ff;
      padding: 20px;
      box-sizing: border-box;
      overflow: hidden;

      .marquee-list {
        span {
          width: 100% !important;
        }
      }

      .chart2 {
        height: 100%;
        width: 100%;
        position: relative;

        h1 {
          position: absolute;
          top: 0px;
          left: 0;
          width: 100%;
          text-align: center;
          color: #00ccff;
          font-size: 1.2em;
        }
      }

      h1 {
        color: #00ccff;
        font-size: 1.5em;
      }

      .units {
        width: 100%;
        height: calc(100% - 30px);
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .unitsErro {
          height: 90px;
          width: 100%;

          .el-carousel--horizontal {
            width: 100%;
            height: 50px;
          }
        }

        .title {
          color: #fff;
          margin: 0;
          height: 25px;
          line-height: 25px;
          font-size: 1em;
          margin-bottom: 15px;
          width: 100%;
          text-align: center;
        }

        .normal {
          width: 100%;
          height: calc(100% - 110px);

          .con {
            overflow: hidden;
            height: calc(100% - 60px);
            width: 100%;

            .marquee-list {
              width: 100%;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;

              div {
                margin-bottom: 10px;
                width: 100%;
                height: 50px;
                line-height: 50px;
                text-align: center;
                background-color: #409eff;
                cursor: pointer;

                span {
                  display: block;

                  button {
                    background: none;
                    color: #fff;
                    border: none;
                    padding: 0;
                    width: 100%;
                    height: 100%;
                  }
                }
              }
            }
          }
        }

        .units-con {
          height: 50px;
          line-height: 50px;
          text-align: center;
          background-color: #409eff;
          cursor: pointer;

          span {
            button {
              background: none;
              color: #fff;
              border: none;
              padding: 0;
              width: 100%;
              height: 100%;
            }
          }
        }

        .animate-up-units {
          transition: all 0.5s ease-in-out;
          transform: translateY(-60px);
        }

        .black {
          background-color: black;
        }

        .green {
          background-color: green;
        }
      }

      .el-tabs {
        height: 100%;
      }

      .unitSelect {
        width: 100%;
        margin-bottom: 10px;
      }

      .unitInfoTitle {
        width: 100%;
        text-align: center;
        font-size: 1.4em;
        height: 30px;
        line-height: 30px;
        display: flex;
        justify-content: center;

        .context {
          margin: 0 10px;
        }

        .dwxxcon_title_1 {
          background: url("/static/img/titlebgl.png") center right no-repeat;
          height: 28px;
          width: 30%;
        }

        .dwxxcon_title_3 {
          background: url("/static/img/titlebgr.png") center left no-repeat;
          height: 28px;
          width: 30%;
        }
      }
    }

    .video-content {
      width: 100%;
      height: calc(100% - 70px);
      margin-top: 10px;
      position: relative;

      .dv-border-box-10 {
        box-shadow: rgb(29, 72, 196) 0px 0px 0px 2px inset !important;
      }

      .swiper-container {
        width: 100%;
        height: 100%;

        .swiper-wrapper {
          width: 100%;
          height: 100%;
        }

        .swiper-slide {
          height: calc((100% - 1.875rem) / 2);

          .video-item {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            color: #ffffff;

            .video-title {
              height: 50px;
              line-height: 50px;
              padding: 0 1.25rem;
              display: flex;
              align-items: center;
              justify-content: space-between;
              background-color: #051d3f;
              cursor: pointer;

              .video-title-status {
                display: flex;
                align-items: center;

                i {
                  display: inline-block;
                  width: 1.25rem;
                  height: 1.25rem;
                  border-radius: 10px;
                  background-color: #00bb00;
                }

                span {
                  padding-left: 10px;
                  color: #237dbf;
                }
              }
            }

            .video-content-content {
              height: calc(100% - 50px);
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #082c61;
            }
          }
        }
      }
    }
  }

  .bot {
    height: calc(50% - 290px);
    margin-top: 30px;
    display: flex;
    justify-content: space-between;

    .scroll {
      padding: 20px;
      box-sizing: border-box;
      height: 100%;
      margin: 0 0.5%;

      // border-radius: 10px;
      // box-shadow: 0 0 5px #00c2ff;
      // -webkit-box-shadow: 0 0 5px #00c2ff;
      h1 {
        width: 100%;
        color: #ffc000;
        font-size: 1.2em;
        height: 28px;
        line-height: 28px;
        display: flex;
        justify-content: space-between;

        .dwxxcon_title_1 {
          background: url("/static/img/titlebgl.png") center right no-repeat;
          height: 28px;
          width: 20%;
        }

        .dwxxcon_title_3 {
          background: url("/static/img/titlebgr.png") center left no-repeat;
          height: 28px;
          width: 20%;
        }
      }
    }

    .chart {
      height: 100%;
      margin: 0 0.5%;
      // border-radius: 10px;
      // box-shadow: 0 0 5px #00c2ff;
      // -webkit-box-shadow: 0 0 5px #00c2ff;
      display: flex;
      justify-content: space-between;

      .content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .pic {
          width: 50%;
          display: flex;
          flex-direction: column;
          h1 {
            margin-top: 15px;
            width: 100%;
            text-align: center;
            margin-bottom: 0;
            color: #fff;
            font-size: 1.2em;
            color: #00ccff;
          }
        }
      }
    }

    .tabs {
      padding: 0;
    }
  }

  .scroll-con {
    margin-top: 15px;
    height: calc(100% - 25px);
    overflow: hidden;

    .marquee-list {
      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 40px;
        line-height: 40px;
        // color: rgba(255,255,255,.5);
        cursor: pointer;
        margin-bottom: 10px;
        border-bottom: solid 1px #0c9cc1;

        p {
          // background-color: #383b73;
          margin: 0;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;

          span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          span:first-child {
            width: 40%;
            display: inline-block;
          }

          span:last-child {
            width: 58%;
            display: inline-block;
            overflow: hidden;
          }
        }

        /*span:first-child {*/
        /*  margin-right: 15px;*/
        /*}*/
      }

      div:hover {
        color: rgba(255, 255, 255, 1);
      }
    }

    .animate-up {
      transition: all 0.5s ease-in-out;
      transform: translateY(-50px);
    }
  }

  .tjcon_1 {
    background: url("/static/img/GF_modbg.png");
    position: relative;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-left-width: 1px;
    border-top-style: solid;
    border-right-style: none;
    border-bottom-style: solid;
    border-left-style: solid;
    border-top-color: #0776ab;
    border-bottom-color: #0776ab;
    border-left-color: #0776ab;
    border-radius: 0 0 0 10px;

    .modification_tl {
      width: 70px;
      height: 55px;
      background: url("/static/img/GF_16.png") no-repeat left;
      position: absolute;
      left: -2px;
      top: -6px;
      z-index: 9;
    }

    .modification_tr {
      width: 7px;
      height: 7px;
      background: url("/static/img/GF_07.png") no-repeat left;
      position: absolute;
      right: 0px;
      top: 0px;
      z-index: 9;
    }

    .modification_br {
      width: 16px;
      height: 18px;
      background: url("/static/img/GF_18.png") no-repeat left;
      position: absolute;
      right: 0px;
      bottom: 0px;
      z-index: 9;
    }

    .modRbg {
      width: 9px;
      height: 100%;
      background: url("/static/img/Lvymod_21.png") no-repeat bottom;
      position: absolute;
      right: 0px;
      top: 0px;
    }

    .modRbg_2 {
      width: 9px;
      height: 100%;
      background: url("/static/img/Lvymod_20.png") no-repeat bottom;
      position: absolute;
      right: 0px;
      top: 0px;
    }
  }
}

// 弹框样式
.modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .modalMain {
    background: #041c68;
    padding: 2rem 3rem;
    //border-radius: 10px;
    border: 2px solid #0efeeb;
    // width: 50%;
    max-height: 80%;
    width: max-content;
    min-width: 30%;
  }

  .tip {
    font-size: 1.2rem;
    margin-bottom: 30px;
    font-weight: bold;
    color: white;

    i {
      color: #faad14;
      font-size: 1.8rem;
      margin-right: 10px;
    }
  }

  .flex-justify-end {
    margin-top: 30px;

    .btn {
      border-radius: 4px;
      padding: 10px 26px;
      background: #1890ff;
      letter-spacing: 4px;
      font-size: 1.2rem;
      color: white;
      cursor: pointer;
    }
  }

  .msg {
    margin-left: 2.7rem;
    line-height: 1.6rem;
  }

  .modalTitle {
    font-size: 1.2rem;
    font-weight: bold;
    color: white;

    i {
      font-size: 1.6rem;
      cursor: pointer;
    }
  }

  .modalCon {
    //margin-top: 50px;
    text-align: left;
    overflow: hidden;

    > div:nth-child(2) {
      margin: 30px 0 10px;
    }

    .msg {
      margin: 30px 0 20px;
      font-size: 1.2rem;
    }

    .ant-avatar-square {
      width: 100% !important;
      height: 400px;
      // padding-bottom: 70%;

      img {
        width: auto;
        height: 100%;
      }
    }

    .image {
      width: 712px;
      height: 400px;
      text-align: center;

      img {
        height: 100%;
        width: auto;
      }
    }

    .pdf {
      overflow: auto;
    }

    .pdf::-webkit-scrollbar {
      width: 0 !important;
    }

    .pdf {
      -ms-overflow-style: none;
    }

    .pdf {
      overflow: -moz-scrollbars-none;
    }
  }
}

/* 定义布局为盒模型 */
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

/* 盒模型垂直布局 */
.flex-v {
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

/* 子元素占据剩余的空间 */
.flex-1 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

/* 子元素垂直两端对齐 */
.flex-align-between {
  //-webkit-box-align: align;
  -webkit-align-content: space-between;
  //-ms-flex-align: align;
  align-content: space-between;
  flex-flow: row wrap;
}

/* 子元素垂直居中 */
.flex-align-center {
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

/* 子元素垂直顶部对齐 */
.flex-align-start {
  -webkit-box-align: start !important;
  //-webkit-align-items: start !important;
  -ms-flex-align: start !important;
  align-items: flex-start !important;
}

/* 子元素垂直底部对齐 */
.flex-align-end {
  -webkit-box-align: end !important;
  //-webkit-align-items: end !important;
  -ms-flex-align: end !important;
  align-items: flex-end !important;
}

/* 子元素水平居中 */
.flex-justify-center {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

/* 子元素两端对齐 */
.flex-justify-between {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

/* 子元素右对齐 */
.flex-justify-end {
  -webkit-box-pack: justify;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: justify;
  justify-content: flex-end;
}

// 换行
.flex-wrap {
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/data.vue